"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSlider = void 0;
var palette_1 = require("../../../theme/global/palette");
var typography_1 = require("../../global/typography");
exports.MuiSlider = {
    root: {
        display: 'flex',
        color: palette_1.palette.primary.main,
        '&$disabled': {
            '& > *': {
                backgroundColor: palette_1.palette.grey[300],
            },
        },
    },
    marked: {},
    disabled: {},
    mark: {
        color: palette_1.palette.grey[300],
        opacity: 1,
        width: '2px',
        height: '8px',
        marginTop: '-3px',
    },
    markActive: {
        backgroundColor: palette_1.palette.primary.main,
        opacity: 1,
    },
    rail: {
        color: palette_1.palette.grey[300],
        // Rounded corners are the ideal, but do not work with marked (interval) sliders.
        // This should be returned once we have figured out how to remove the first and last marks, or remove the rounded corners when marks are active
        // borderRadius: '2px',
        opacity: 1,
        height: '4px',
        marginTop: '-1px',
    },
    track: {
        // Rounded corners are the ideal, but do not work with marked (interval) sliders.
        // This should be returned once we have figured out how to remove the first and last marks, or remove the rounded corners when marks are active
        // borderRadius: '2px',
        height: '4px',
        marginTop: '-1px',
    },
    thumb: {
        backgroundColor: palette_1.palette.common.white,
        border: "3px solid ".concat(palette_1.palette.primary.main),
        marginTop: '-9px',
        height: '20px',
        width: '20px',
        '&$disabled': {
            backgroundColor: palette_1.palette.common.white,
            border: "3px solid ".concat(palette_1.palette.grey[300]),
            marginTop: '-9px',
            height: '20px',
            width: '20px',
        },
        //1A is 0.1 opacity in hexa
        '&:hover': {
            boxShadow: "0px 0px 0px 8px ".concat(palette_1.palette.primary.main, "1A"),
        },
        '&:active': {
            boxShadow: "0px 0px 0px 14px ".concat(palette_1.palette.primary.main, "1A"),
        },
    },
    valueLabel: __assign(__assign({ top: '-24px', left: '-5px' }, typography_1.typography.h5), { fontSize: 11, '& > *': {
            backgroundColor: palette_1.palette.grey[800],
            width: '24px',
            height: '24px',
            borderRadius: '50% 50% 50% 0',
            transform: 'rotate(-45deg)',
            '& > *': {
                transform: 'rotate(45deg)',
            },
        } }),
};
